const loadMoreEventBtn = document.querySelector('#expand-event');
const loadMoreEventBtnWrapper = document.querySelector('.expand-event-btn');
const loadMoreEventBtnWrapperOffsetTop =
  loadMoreEventBtnWrapper.offsetParent.offsetTop;
const showLessEventBtn = document.querySelector('#showless-event');
const eventTitleEls = document.querySelectorAll('.event-list__name a');
const eventEls = document.querySelectorAll('.event-list__item .item');
const eventElsFromTwo = document.querySelectorAll(
  '.event-list__item .item.item__from_two '
);
const eventItemsInfoElChange = document.querySelectorAll(
  '.event-list__item .item .event-item .event_info.evt-change'
);
const eventItemsElFirst = document.querySelectorAll(
  '.event-list__item .item .event-item.event-item-first'
);
const eventItemsElSecond = document.querySelectorAll(
  '.event-list__item .item .event-item.event-item-second'
);
const eventItemsEl = document.querySelectorAll(
  '.event-list__item .item .event-item'
);
const eventItemsInfoEl = document.querySelectorAll(
  '.event-list__item .item .event-item .event_info'
);
const eventItemsHeadingEl = document.querySelectorAll(
  '.event-list__item .item .heading-blur'
);
loadMoreEventBtn.addEventListener('click', function () {
  eventEls.forEach((c) => {
    c.classList.remove('event-hide');
  });
  eventItemsEl.forEach((c) => {
    c.classList.remove('event-hide');
    c.classList.remove('has-over-bg');
  });
  eventItemsInfoEl.forEach((c) => {
    c.style.height = 'auto';
  });
  eventItemsHeadingEl.forEach((c) => {
    c.style.opacity = '1';
  });
  loadMoreEventBtn.style.display = 'none';
  loadMoreEventBtnWrapper.style.display = 'none';
  showLessEventBtn.style.display = 'block';
  setTimeout(() => {
    AOS.refreshHard();
  }, 1000);
});
showLessEventBtn.addEventListener('click', function () {
  eventElsFromTwo.forEach((c) => {
    c.classList.add('event-hide');
  });
  eventItemsElFirst.forEach((c) => {
    c.style.display = 'block';
    c.classList.add('has-over-bg');
  });
  eventItemsElSecond.forEach((c) => {
    c.classList.add('event-hide');
  });
  eventItemsInfoElChange.forEach((c) => {
    c.style.height = '20px';
  });
  loadMoreEventBtn.style.display = 'block';
  loadMoreEventBtnWrapper.style.display = 'block';
  showLessEventBtn.style.display = 'none';
  window.scrollTo({
    top: loadMoreEventBtnWrapperOffsetTop,
    behavior: 'smooth',
  });
});
eventTitleEls.forEach((t) => {
  t.addEventListener('click', function () {
    let eventYear = t.dataset.year;
    let itemEl = document.getElementById('event_year_' + eventYear);
    loadMoreEventBtn.click();
    window.scrollTo({ top: itemEl.offsetTop, behavior: 'smooth' });
  });
});
